import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreatePerson } from "~pages/Persons/types/upsertPerson.ts";
import type { Person, PersonResponse } from "~types/person.ts";

export const useCreatePerson = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<Person, Error, CreatePerson>({
    mutationFn: async (body) => {
      const response = await request<PersonResponse>(`${sport}/o/${organizationId}/persons`, {
        method: "POST",
        body,
      });

      return response?.data?.[0];
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["persons"] }),
        queryClient.invalidateQueries({ queryKey: ["persons", sport, organizationId] }),
      ]);
    },
  });
};
